//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  props: {
    basketCounter: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters('sale', ['basketType']),
  },
  methods: {
    openBasketModal() {
      this.debug({ name: 'openBasketDialog' });

      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'ds_click',
        eventAction: 'to_checkout',
      });

      this.$store.commit('sale/setBasketDialog', true);
    },
  },
};
